/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { connectStateResults, connectStats } from "react-instantsearch-dom";

import { CustomHits } from "src/components/Search/Hits/Hits";
import { numberWithCommas } from "src/lib/utils/strings";

/**
 * Instant Search Component for custom hit logic.
 * Docs: https://www.algolia.com/doc/api-reference/widgets/state-results/react/
 */
const StateResults = ({ searchState }: any) => {
  return <>{searchState && searchState.query && <CustomHits />}</>;
};

export const CustomStateResults: any = connectStateResults(StateResults);

/**
 * Instant Search Component that shows the number of search results.
 * Docs: https://www.algolia.com/doc/api-reference/widgets/stats/react/
 */
const Stats = ({ nbHits }: { nbHits: number }) => <span>{numberWithCommas(nbHits)} Results</span>;

export const CustomStats: any = connectStats(Stats);
